module.exports = __webpack_public_path__ + "static/media/sweets.89ad2a32.pdf";